import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/views/app/Index'),
      redirect: '/dashboard',

      children: [
        {
          path: '/dashboard',
          component: () => import('@/views/app/dashboard/Route'),
          children: [
            {
              name: 'DashboardPage',
              path: '',
              component: () => import('@/views/app/dashboard/Dashboard'),
              meta: { onlyAuthUser: true },
            },
          ],
        },
        {
          path: '/packages',
          component: () => import('@/views/app/pages/Pages'),
          children: [
            {
              name: 'PackagesPage',
              path: '',
              component: () => import('@/views/app/package/Packages'),
              meta: { onlyAuthUser: true },
            },
            {
              path: ':package_id',
              name: 'PackagePage',
              component: () => import('@/views/app/package/Package'),
              meta: { onlyAuthUser: true },
            },
          ],
        },
        {
          path: '/instances',
          component: () => import('@/views/app/pages/Pages'),
          children: [
            {
              name: 'InstancesPage',
              path: '',
              component: () => import('@/views/app/instance/Instances'),
              meta: { onlyAuthUser: true },
            },
          ],
        },
      ],
    },
    {
      path: '/signin',
      component: () => import('@/views/app/sessions/Sessions'),
      children: [
        {
          name: 'SignIn',
          path: '',
          component: () => import('@/views/app/sessions/SignIn'),
          meta: { onlyGuestUser: true },
        },
      ],
    },
    {
      path: '*',
      redirect: '/dashboard',
    },
  ],
  data () {
    return {
      prevRoute: null,
    }
  },
})

router.beforeEach((to, from, next) => {
  router.prevRoute = from
  store.dispatch('tryAutoLogin')
    .then(() => {
      const { isAuthenticated } = store.getters

      if (isAuthenticated && to.meta.onlyGuestUser) {
        next({ path: '/' })
      } else if (!isAuthenticated && to.meta.onlyAuthUser) {
        next({ name: 'SignIn' })
      } else {
        next()
      }
    })
    .catch(() => {
      next({ name: 'SignIn' })
    })
})

export default router
